import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles({
  root: {
    background: ({color}) =>
      color === 'transparent'
        ? 'transparent' :
      color === 'success'
        ? 'linear-gradient(40deg, #277661 -20%, #29DEAE 70%)' :
      color === 'danger'
        ? 'linear-gradient(40deg, #FF0000 30%, #FB4B6B 90%)' :
      color === 'warning'
        ? 'linear-gradient(40deg, #FF7A00 30%, #FFBB38 90%)'
        : 'linear-gradient(40deg, #3f51b5 30%, #62a0fe 90%)',
    border: ({color}) => color === 'transparent' ? '2px solid' : 0,
    borderRadius: 5,
    color: ({color}) => color === 'transparent' ? '#277661' : '#fff',
    height: 42,
    padding: '0 38px',
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '110%'
  },
});

const DefaultButton = (props) => {
  const {color, className, ...other} = props;
  const classes = useStyles(props);
  return <Button className={`${classes.root} ${className}`} {...other} />;
};

DefaultButton.propTypes = {
  color: PropTypes.oneOf(['primary', 'danger', 'warning', 'success', 'transparent']).isRequired,
};

export default DefaultButton;